import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MobileNavButton = ({ onClick, navOpen }) => (
  <MobileNavBtn onClick={onClick} navOpen={navOpen} aria-label="Toggle mobile navigation" aria-pressed={navOpen}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 32">
      <g fill="none" stroke="currentColor" strokeWidth="3">
        <path strokeDashoffset="-69.4" strokeDasharray="62 200" d="M30.567 33c0-4.813-8.46-12.601-13.017-19.323C14.697 9.468 9.382 1.414 8.987-.683 8.335-4.143 4.899-6.275.69-4.155-6.2-.683-3.67 4.671-2.96 6.791c.852 2.536 3.07 4.006 3.07 4.006S5.33 15.34 27.618 7.3C49.905-.739 60 2.41 60 2.41" />
        <path strokeDashoffset="-84" strokeDasharray="62 200" d="M19.357 16.128C20.962 3.6 19.279-5.005 14.307-9.69 6.852-16.716-7.207-12.136-10.39.075-12.512 8.215-9.096 14.92-.143 20.192c0 0 5.243 4.644 27.624-3.571 22.381-8.216 32.519-5 32.519-5" />
        <path strokeDashoffset="-144" strokeDasharray="62 200" d="M6.47 33c0-4.409 6.43-11.813 13.224-17.095 6.83-5.31 11.13-9.546 10.498-15.815-.631-6.27-3.175-10.771-8.782-15.27-9.616-7.717-30.382-3.35-36.017 9.569-5.846 13.401-.98 24.942 14.594 34.62 0 0 5.232 4.502 27.565-3.461C49.884 17.585 60 20.702 60 20.702" />
      </g>
    </svg>
  </MobileNavBtn>
);

const MobileNavBtn = styled.button`
  display: inline-block;
  margin-bottom: 1px;
  padding: 0;
  appearance: none;
  border: 0;
  background-color: transparent;
  color: ${props => props.navOpen ? props.theme.black : 'rgb(var(--mobile-nav-item-color))'};
  outline: none;
  transition: color .2s ease-in;

  svg {
    display: block;
    width: 30px;
    height: 16px;
    pointer-events: none;
    position: relative;
    overflow: visible !important;

    path {
      shape-rendering: geometricPrecision;
      transition: transform .3s linear, stroke-dasharray .5s ease-in, stroke-dashoffset .5s ease-in;

      ${props => props.navOpen && `
        stroke-dashoffset: 0;
        stroke-dasharray: 0 200;
        transform: translateX(22%);

        &:first-child {
          stroke-dashoffset: -1;
          stroke-dasharray: 38.5 200;
        }

        &:last-child{
          stroke-dashoffset: -1;
          stroke-dasharray: 41 200;
        }`};
    }
  }
`;

MobileNavButton.propTypes = {
  onClick: PropTypes.func,
};

export default MobileNavButton;
